
//ko.bindingHandlers.inViewport = {
//    init: function (element, valueAccessor, allBindings, viewModel, bindingContext)
//    {


//        new IntersectionObserver(() =>
//        {

//        }, { threshold: 1.0 });

//        //const eventHandler = (evt) =>
//        //{
//        //    if (evt.key === 'Enter')
//        //        ko.unwrap(valueAccessor()).call(null, viewModel, evt);

//        //}

//        //element.addEventListener('keydown', eventHandler)

//        //ko.utils.domNodeDisposal.addDisposeCallback(element, () =>
//        //{
//        //    element.removeEventListener('keypress', eventHandler)
//        //});

//    }
//};
